jQuery(function($) {

	var $form = $('#enroll-form');
	var $userName = $('#user-name');
	var $userEmail = $('#user-email');
	var $courseId = $('#course-id');
	var blockForm = false;

	$userName.on('keydown', reset_error);
	$userEmail.on('keydown', reset_error);

	function reset_error() {
		$(this).removeClass('error');
	}

	$form.on('submit', function (e) {
		e.preventDefault();
		if( blockForm )
			return;

		$('#enroll-error').removeClass('show');

		var data = {
			'action': 'enroll-course',
			'name': $userName.val(),
			'email': $userEmail.val(),
			'course': $courseId.val()
		};
		var error = false;
		if( !data.email || !/^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(data.email) ) {
			$userEmail.addClass('error').focus();
			error = true;
		}
		if( !data.name ) {
			$userName.addClass('error').focus();
			error = true;
		}

		if( !error ) {
			blockForm = true;
			var ajax_url = base_url + '/wp-admin/admin-ajax.php';
			$.post(ajax_url, data, function(result) {
				$(result.success ? '#enroll-success' : '#enroll-error').addClass('show');
				if( !result.success )
					blockForm = false;
			});
		}

	})

});
